import React from 'react'
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  header: {
    marginBottom: 30
  },
  subheader: {
    marginBottom: 10
  },
  input: {
    marginBottom: 30
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: "44px 60px",
      minWidth: "500px"
    }
  },
  loginBackground: {
    backgroundImage: `url(${"assets/login-background.jpg"})`,
    backgroundSize: "cover"
  }
});

export const Card = withStyles(styles)(({children, classes}) => {
  return <Paper className={classes.paper}>{children}</Paper>
})